export interface PanelTabProps {
  readonly label: string;
  readonly isActive: boolean;
  readonly onClick: () => void;
  readonly icon?: React.ComponentType<{ className?: string | undefined }>;
}

export function PanelTab({ label, isActive, onClick, icon: Icon }: PanelTabProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        'flex-1 border-b-thin px-micro py-nano !font-medium transition-colors ts-caption-xxs',
        isActive
          ? 'border-ctx-interactive-primary text-ctx-interactive-primary'
          : 'border-base-neutral-none text-ctx-content-placeholder hover:text-ctx-content-base',
      ].join(' ')}
    >
      <span className="flex items-center justify-center gap-quark">
        {Icon && <Icon className="h-micro w-micro shrink-0" />}
        {label}
      </span>
    </button>
  );
}
